const LOADER_SHOWN_GLOBAL = 'LOADER_SHOWN_GLOBAL';

export default {
	namespaced: true,
	state: {
		loaderShownGlobal: false
	},
	actions: {
		setLoaderShownGlobal({commit}, loaderShownGlobal) {
			commit(LOADER_SHOWN_GLOBAL, loaderShownGlobal);
		}
	},
	mutations: {
		[LOADER_SHOWN_GLOBAL](state, loaderShownGlobal) {
			state.loaderShownGlobal = loaderShownGlobal;
		}
	}
};



// WEBPACK FOOTER //
// ../source/common/component-loader/component-loader-vuex.js